import { Fab, Theme, withStyles, FabProps } from '@material-ui/core';
import { forwardRef } from 'react';
import { ColoredCommonProps, withColoredStyles } from './common';

type ColoredFab = {
  <C extends React.ElementType>(
    props: FabProps<C, { component?: C }> & ColoredCommonProps
  ): JSX.Element;
};

export const ColoredFab: ColoredFab = withColoredStyles(
  forwardRef(({ colored, coloredHover, ...props }: any, ref) => <Fab ref={ref} {...props} />)
) as ColoredFab;
